import { Card, CardBody, CardHeader } from "reactstrap";
import AdminOnlyAccess from "../components/common/base/AdminOnlyAccess";
import InstallationSettings from "../components/installations/InstallationSettings";

export default function InstallationSettingsView() {
  return (
    <AdminOnlyAccess>
      <div className="content">
        <Card>
          <CardHeader>
            <h5 className="card-category text-uppercase mb-0">Installation Settings</h5>
          </CardHeader>
          <CardBody>
            <InstallationSettings />
          </CardBody>
        </Card>
      </div>
    </AdminOnlyAccess>
  );
}
